import { Capacitor, registerPlugin } from '@capacitor/core';

/**
 * KA1b: telefonens batteri i iOS-appen. WKWebView saknar navigator.getBattery, så NativeBattery-pluginet
 * (iOS BatteryPlugin i ios/App/App/ViewController.swift) läser UIDevice. Android WebView har getBattery
 * och behöver inget plugin.
 */
export type BatteryReading = { level: number; charging: boolean };

const NativeBattery = registerPlugin<{ getBattery(): Promise<{ level: number; charging: boolean }> }>('NativeBattery');

/** UIDevice ger -1 när nivån är okänd (simulatorn, övervakning av); ogiltigt värde → null så ingenting skickas. */
export function normalizeBattery(r: { level?: number; charging?: boolean } | null | undefined): BatteryReading | null {
  if (!r || typeof r.level !== 'number' || !Number.isFinite(r.level) || r.level < 0 || r.level > 1) return null;
  return { level: r.level, charging: !!r.charging };
}

/** Native batteri i iOS-appen; null i webbläsaren, på Android eller när nivån är okänd. */
export async function nativeBattery(): Promise<BatteryReading | null> {
  if (Capacitor.getPlatform() !== 'ios') return null;
  try { return normalizeBattery(await NativeBattery.getBattery()); } catch { return null; }
}
